<template>
  <div class="server-box">
    <div class="swiper-item">
      <div class="swiper-body">
        <div class="swiper-title">全链全生命周期开发服务流程</div>
        <div class="swiper-desc">涵盖开发流程中的各个阶段，包括：需求调研、需求分析、产品设计、产品研发、测试上线、售后维护、部署以及实施后的支持。</div>
        <div class="more" @click="$router.push('/hzdz')">
          <img src="../../../../static/images/home_button@2x.png" />
          <span>立即咨询</span>
        </div>
      </div>
      <figure class="swiper-bg"></figure>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    }
  }
</script>
<style scoped>
.swiper-item {
  color: #ffffff;
  height: 672px;
  overflow: hidden;
  position: relative;
}
.swiper-body {
  max-width: 1200px;
  margin: 180px auto 0;
  font-size:14px;
}
.swiper-title {
  font-size: 2em;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(250,250,250,1);
  font-weight:bold;
}
.swiper-desc {
  font-size:1em;
  font-family:Microsoft YaHei;
  font-weight:400;
  line-height:26px;
  margin-top: 30px;
  width:495px;
  color:rgba(255,255,255,1);
}
.swiper-bg {
  width: 1920px;
  height: 672px;
  background-size: 1920px 672px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
  background-image: url('https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_process.gif');
}
.more {
  width:176px;
  height:48px;
  background:rgba(255,87,78,1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size:18px;
  color:rgba(255,255,255,1);
  margin: 60px 0 0 0;
  cursor: pointer;
  position: relative;
}
.more:hover {
  background:#dc170d;
}
.more img {
  width: 24px;
  height: 24px;
  transform: translateY(1px);
  margin-right: 8px;
}
@media (max-width: 1199px) and (min-width: 992px){
  .swiper-body {
    padding: 0 20px;
    font-size: 13px;
  }
}
@media (max-width: 991px) and (min-width: 768px){
  .swiper-body {
    padding: 0 20px;
    font-size: 12px;
  }
}
@media screen and (max-width: 767px){
  .swiper-body {
    padding: 0 20px;
    font-size: 12px;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/index/service/serviceprocess.vue